import React, { useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import {Link} from 'react-router-dom'
import Curriculumleft from './Curriculumleft'


const Btech_curriculumEle = () => {
    const calendarsData = [

        {
            cname: "Engineering Physics",
            url: "#",
            glow: false,
            SubHeading: false,
        },
        {
            cname: "2024 - Batch Onwards",
            url: "https://files.iittp.ac.in/pdfs/curriculum/2024/EP.pdf",
            glow: false,
            SubHeading: true,
        },

        // First
        {
            cname: "Chemical Engineering",
            url: "#",
            glow: false,
            SubHeading: false,
        },
        {
            cname: "2023 - Batch Onwards",
            url:"https://files.iittp.ac.in//pdfs/curriculum/2024/CH.pdf",
            glow: false,
            SubHeading: true,
        },
        {
            cname: "2019 - Batch Onwards",
            url:
                "https://files.iittp.ac.in/pdfs/curriculum/2019/B.Tech%20Curriculum-2019_CH_New.pdf",
            glow: false,
            SubHeading: true,
        },
        {
            cname: "2018 - Batch",
            url:"https://files.iittp.ac.in/pdfs/curriculum/BTechCurriculum-CH.pdf",
            glow: false,
            SubHeading: true  
        },     
        // Second
        {
             cname: "Civil Engineering",
                url: '#',
                glow: false,
                SubHeading: false
        },
        {
            cname: "2023 - Batch Onwards",
            url: 'https://files.iittp.ac.in/pdfs/curriculum/2024/CEE_CURRICULUM_05.03.2024.pdf',            
            glow: false,
            SubHeading: true
        },
        {
            cname: "2019 - Batch Onwards",
            url: 'https://files.iittp.ac.in/pdfs/curriculum/2019/B.Tech%20Curriculum-2019_CE_New.pdf',
            glow: false,
            SubHeading: true
        },
        {
            cname: "2018 - Batch",
            url: 'https://files.iittp.ac.in/pdfs/curriculum/Curriculum-Civil-2018.pdf',
            glow: false,
            SubHeading: true
        },
        {
            cname: "2016 - Batch",
            url: 'https://files.iittp.ac.in/images/demo/iit/curriculums/CE_Curriculum_2016.pdf',
            glow: false,
            SubHeading: true
        },
        {
            cname: "2015 - Batch",
            url: 'https://files.iittp.ac.in/images/demo/iit/curriculums/CE_Curriculum_2015.pdf',
            glow: false,
            SubHeading: true
        },



        // third
        {
            cname: "Computer Science Engineering",
            url: '#',
            glow: false,
            SubHeading: false
        },

        {
            cname: "2023 - Batch Onwards",
            url: 'https://files.iittp.ac.in/pdfs/curriculum/2024/CSE_Curriculam_05.03.2024.pdf',
            glow: false,
            SubHeading: true
        },
        {
            cname: "2019 - Batch Onwards",
            url: 'https://files.iittp.ac.in/pdfs/curriculum/2019/B.Tech%20Curriculum-2019_CS_New.pdf',
            glow: false,
            SubHeading: true
        },
        {
            cname: "2018 - Batch",
            url: 'https://files.iittp.ac.in/pdfs/curriculum/Curriculum-CSE-2018.pdf',
            glow: false,
            SubHeading: true
        },
        {
            cname: "2017 - Batch",
            url: 'https://files.iittp.ac.in/pdfs/curriculum/cse_curriculum_batch_2017.pdf',
            glow: false,
            SubHeading: true
        },
        {
            cname: "2016 - Batch",
            url: 'https://files.iittp.ac.in/pdfs/curriculum/cse_curriculum_2016_batch.pdf',
            glow: false,
            SubHeading: true
        },
        {
            cname: "2015 - Batch",
            url: 'https://files.iittp.ac.in/images/demo/iit/curriculums/CSE_Curriculum.pdf',
            glow: false,
            SubHeading: true
        },


        // four
        {
            cname: "Electrical Engineering",
            url: '#',
            glow: false,
            SubHeading: false
        },

        {
            cname: "2023 - Batch Onwards",
            url: 'https://files.iittp.ac.in/pdfs/curriculum/2024/EE.pdf',
            glow: false,
            SubHeading: true
        },
        {
            cname: "2019 - Batch Onwards",
            url: 'https://files.iittp.ac.in/pdfs/curriculum/2019/B.Tech%20Curriculum-2019_EE_New.pdf',
            glow: false,
            SubHeading: true
        },
        {
            cname: "2018 - Batch",
            url: 'https://files.iittp.ac.in/pdfs/curriculum/Curriculum-EE-2018.pdf',
            glow: false,
            SubHeading: true
        },
        {
            cname: "2015 - Batch",
            url: 'https://files.iittp.ac.in/images/demo/iit/curriculums/EE-Curriculum-2015.pdf',
            glow: false,
            SubHeading: true
        },
        {
            cname: "2016 - Batch",
            url: 'https://files.iittp.ac.in/images/demo/iit/curriculums/EE-Curriculum-2016.pdf',
            glow: false,
            SubHeading: true
        },


        // fifth
        {
            cname: "Mechanical Engineering",
            url: '#',
            glow: false,
            SubHeading: false
        },

        {
            cname: "2023 - Batch Onwards",
            url: 'https://files.iittp.ac.in/pdfs/curriculum/2024/ME_CURRICULUM_05.03.2024.pdf',
            glow: false,
            SubHeading: true
        },
        {
            cname: "2019 - Batch Onwards",
            url: 'https://files.iittp.ac.in/pdfs/curriculum/2019/B.Tech%20Curriculum-2019_ME_Updated.pdf',
            glow: false,
            SubHeading: true
        },
        {
            cname: "2018 - Batch",
            url: 'https://files.iittp.ac.in/pdfs/curriculum/Curriculum-ME-2018.pdf',
            glow: false,
            SubHeading: true
        },
        {
            cname: "2015 - 2017 Batches",
            url: 'https://files.iittp.ac.in/images/demo/iit/curriculums/ME_Curriculum.pdf',
            glow: false,
            SubHeading: true
        }

    ];


    return (
        <section className="project-detail">
            <Container>
                <Row>
                    <Col md={4} className='c-left custom-padding-color mb-4'>           
                        <Curriculumleft activeIndex={0} />
                    </Col>

                    <Col md={8} className='c-right mt-2 ps-5'>
                        <h3 className='text-center mb-5'>B.Tech Curriculum</h3>
                        <h5>Curriculum for B.Tech Programs are listed as below:</h5>
                                <ul className='ms-4 mt-4 fs-5'>
                                    {calendarsData.map((value, index) => {
                                        return (
                                            <li className='c-lineheight3' key={index}>
                                                <span className={`${value.SubHeading ? 'ms-5' : ''}`}></span>
                                                <i className="fas fa-file-pdf me-3 text-danger"></i>
                                                
                                                <Link to={value.url} target="_blank">

                                                    <span className={`${value.glow ? 'test' : ''}`}>
                                                        {value.cname}
                                                    </span>
                                                    
                                                </Link>
                                            </li>
                                        );
                                    })}
                                </ul>
                    </Col>
                </Row>
            </Container>
        </section>            
     
    );
};


export default Btech_curriculumEle;
